<template>
  <slot v-if="!error" />
  <div v-else class="error-boundary">
    <p>页面加载出错</p>
    <button @click="reset">重试</button>
  </div>
</template>

<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue'

const error = ref<Error | null>(null)

onErrorCaptured((err) => {
  error.value = err
  return false
})

function reset() {
  error.value = null
}
</script>

<style scoped>
.error-boundary {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 16px;
  color: var(--c-text-2);
  font-family: var(--c-font-sans, 'Geist', 'Inter', sans-serif);
}

.error-boundary p {
  font-size: 15px;
  font-weight: 500;
  margin: 0;
}

.error-boundary button {
  padding: 8px 20px;
  border: 1px solid var(--c-border-1);
  border-radius: var(--c-radius, 8px);
  background: transparent;
  color: var(--c-text-1);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
}

.error-boundary button:hover {
  background: var(--c-bg-subtle);
  border-color: var(--c-border-2);
}
</style>
